var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrnMapHelpAreasOfFocus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "41px",
    height: "36px",
    viewBox: "0 0 41 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BRN---Mapping-the-Network---Instructions",
    transform: "translate(-488.000000, -536.000000)",
    fill: "#FFFFFF",
    stroke: "#0177CB",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(490.000000, 538.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1743824,0.438307084 C28.1667054,-2.19687803 39.4922223,7.34922313 36.5200393,21.0424266 C34.1416402,32 19.9148103,34.6181508 9.74183911,29.440446 C-6.3799062,21.2350124 -1.28377267,4.27455056 16.1743824,0.438307084 Z",
    id: "Path-3-Copy-2",
    transform: "translate(18.500000, 16.000000) scale(-1, 1) translate(-18.500000, -16.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9286368,5.28763902 C25.0315577,3.55829879 32.683934,9.82292768 30.6757022,18.8090924 C29.0686758,26 19.4559529,27.7181615 12.5823237,24.3202927 C1.68925257,18.9354769 5.13258603,7.8051738 16.9286368,5.28763902 Z",
    id: "Path-3-Copy-2",
    transform: "translate(18.500000, 15.500000) scale(-1, 1) translate(-18.500000, -15.500000) "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrnMapHelpAreasOfFocus);
export default __webpack_public_path__ + "static/media/BRN-Map-Help-AreasOfFocus.2491fa7bc89ac3a3ec1c97f437d4497b.svg";
export { ForwardRef as ReactComponent };